import { render, staticRenderFns } from "./AvtBlagajna.vue?vue&type=template&id=bc6f1494&scoped=true&"
import script from "./AvtBlagajna.vue?vue&type=script&lang=js&"
export * from "./AvtBlagajna.vue?vue&type=script&lang=js&"
import style0 from "./AvtBlagajna.vue?vue&type=style&index=0&id=bc6f1494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6f1494",
  null
  
)

component.options.__file = "AvtBlagajna.vue"
export default component.exports